import React from 'react';
import { AccordionContext } from '@/generic-components/checkout/accordion';
import BypassIfComplete from '@/generic-components/checkout/accordion/bypass-if-complete';
import { AccordionSectionContext } from '@/generic-components/checkout/accordion/section';
import { CheckoutContext } from '../accordion';
import Overview from '.';

export interface ICompleteSection {
  completeSection: (summary: any) => void;
}
const OverwiverWrapper = () => {
  return (
    <CheckoutContext.Consumer>
      {({ basket, checkoutCms, ecProducts }) => (
        <AccordionContext.Consumer>
          {({ neverBypassActiveSection }) => (
            <AccordionSectionContext.Consumer>
              {({ completeSection }) => (
                <BypassIfComplete
                  onBypass={completeSection}
                  isComplete={false} // Need to look further
                  neverBypass={neverBypassActiveSection}
                >
                  <Overview
                    basket={basket}
                    setActiveSection={completeSection}
                    checkoutCms={checkoutCms}
                    ecProducts={ecProducts}
                  />
                </BypassIfComplete>
              )}
            </AccordionSectionContext.Consumer>
          )}
        </AccordionContext.Consumer>
      )}
    </CheckoutContext.Consumer>
  );
};

export default OverwiverWrapper;
